import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "order-filled-toast__header" }
const _hoisted_2 = { class: "order-filled-toast__title" }
const _hoisted_3 = { class: "order-filled-toast__side" }
const _hoisted_4 = { class: "order-filled-toast__label" }
const _hoisted_5 = { class: "order-filled-toast__currency" }
const _hoisted_6 = { class: "order-filled-toast__label" }
const _hoisted_7 = { class: "order-filled-toast__currency" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import SimpleToast from '../SimpleToast.vue';
import SimpleToastMessage from '../SimpleToastMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFilledToast',
  props: {
  order: { type: Object, required: true },
  market: { type: Object, required: true },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const sideVariant = computed(() => (props.order.side === 'BUY' ? 'primary' : 'secondary'));
const sideClass = computed(() => (props.order.side === 'BUY' ? 'buy' : 'sell'));
const filled = computed(() => t('modules.myOrders.toasts.filled.title'));
const side = computed(() => t(`fundamentals.orders.side.${props.order.side.toLowerCase()}`).toUpperCase());
const amount = computed(() => t('modules.myOrders.toasts.filled.amount'));
const price = computed(() => t('modules.myOrders.toasts.filled.price'));

return (_ctx: any,_cache: any) => {
  const _component_ot_number_display = _resolveComponent("ot-number-display")!

  return (_openBlock(), _createBlock(SimpleToast, {
    class: _normalizeClass(["order-filled-toast", [`order-filled-toast--${sideClass.value}`]]),
    variant: sideVariant.value,
    "show-icon": false,
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(filled.value), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(side.value), 1)
      ])
    ]),
    message: _withCtx(() => [
      _createVNode(SimpleToastMessage, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(amount.value), 1),
          _createVNode(_component_ot_number_display, {
            class: "order-filled-toast__amount",
            number: __props.order.amount,
            precision: __props.order.getAmountPrecision(__props.market)
          }, null, 8, ["number", "precision"]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.order.baseCurrencyCode), 1)
        ]),
        _: 1
      }),
      (!__props.order.isMarketOrder)
        ? (_openBlock(), _createBlock(SimpleToastMessage, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(price.value), 1),
              _createVNode(_component_ot_number_display, {
                class: "order-filled-toast__amount",
                number: __props.order.displayPrice,
                precision: __props.order.getMarketPrecision(__props.market)
              }, null, 8, ["number", "precision"]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(__props.order.quoteCurrencyCode), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "variant"]))
}
}

})